import React from 'react';
import ReactDOM from "react-dom";
import QrscannerComponent from './components/_qrscannerComponent.jsx';

const page = document.getElementById('qrscanner_container');

function closeScanner() {
	ReactDOM.unmountComponentAtNode(page);
}

if (page) {
	let flags = JSON.parse(page.dataset.flags);
	document.querySelectorAll('[data-qrscanner="open"]').forEach(function(btn) {
		btn.addEventListener('click', function(event) {
			event.preventDefault();
			ReactDOM.render(<QrscannerComponent value={flags} close={closeScanner} />, page);
		});
	});
}




/*



import QrScanner from 'qr-scanner';

const page = document.getElementById('qrscanner');
if (page) {
	const videoElem = page.querySelector('video');
	const result = page.querySelector('.results');
	const divResult = result.querySelector('.result');
	const qrScanner = new QrScanner(videoElem,
		result => processQrcode(result),
		{
			highlightScanRegion: true,
			highlightCodeOutline: true,
		}
	);
	let flag = '';

	document.querySelectorAll('[data-qrscanner="open"]').forEach(function(btn) {
		btn.addEventListener('click', function(event) {
			event.preventDefault();
			page.classList.remove('_active');
			flag = '';
			page.classList.add('_opened');
			//qrScanner.start();
		});
	});

	page.querySelectorAll('[data-flag]').forEach(function(btn) {
		btn.addEventListener('click', function(event) {
			event.preventDefault();
			flag = parseInt(btn.dataset.flag);
			document.getElementById('scan_title').innerHTML = 'Scan ' + btn.textContent;
			page.classList.add('_active');
			qrScanner.start();
		});
	});

	document.querySelectorAll('[data-qrscanner="close"]').forEach(function(btn) {
		btn.addEventListener('click', function(event) {
			event.preventDefault();
			page.classList.remove('_opened');
			qrScanner.stop();
		});
	});

	document.querySelectorAll('[data-scan]').forEach(function(btn) {
		btn.addEventListener('click', function(event) {
			event.preventDefault();
			result.classList.remove('_visible');
			qrScanner.start();
		});
	});

	function processQrcode(code) {
		qrScanner.stop();

		const types = [ 'success', 'warning', 'error', 'confirm' ];
		divResult.classList.remove(...types);
		divResult.classList.remove('_visible');
		divResult.querySelectorAll('.d-none').forEach(function(el) {
			el.classList.remove('d-none');
		});

		result.classList.add('_visible', '_loading');

		let formData = new FormData();
		formData.append('action', 'scanqr');
		formData.append('flag', flag);
		formData.append('code', code.data);

		fetch('', {
			method: 'POST',
			headers: { 'X-Requested-With': 'XMLHttpRequest' },
			body: new URLSearchParams(formData)
		})
		.then(response => response.json())
		.then(function(data) {
			// modal
			let type = 'error';
			if (data.hasOwnProperty('type') && types.indexOf(data.type) != -1) {
				type = data.type;
			}
			divResult.classList.add(type);
			
			if ( data.hasOwnProperty('msg_alert') )
				divResult.querySelector('.msg_alert').innerHTML = data.msg_alert;
			else
				divResult.querySelector('.msg_alert').classList.add('d-none');

			if ( data.hasOwnProperty('contact') ) {
				for (const property in data.contact) {
					let el = divResult.querySelector('.contact .' + property);
					if (el)
						el.innerHTML = data.contact[property];
				}
			}
			else
				divResult.querySelector('.contact').classList.add('d-none');

			if ( data.hasOwnProperty('msg') )
				divResult.querySelector('.msg').innerHTML = data.msg;
			else
				divResult.querySelector('.msg').classList.add('d-none');
			result.classList.remove('_loading');
			divResult.classList.add('_visible');

			// list
			if (data.success && data.hasOwnProperty('contact_id') && data.hasOwnProperty('flag_id')) {
				if (data.hasOwnProperty('flag_dates')) {
					let value = '<div class="mb-2">';
					value += '<a data-bs-toggle="collapse" href="#dates_' + flagLink.dataset.flag + '_' + flagLink.dataset.contact + '"><strong>' + data.flag_dates.length + ' activation' + ( data.flag_dates.length > 1 ? 's' : '' ) + '</strong></a>';
					value += '<div class="collapse" id="dates_' + flagLink.dataset.flag + '_' + flagLink.dataset.contact + '">';
					for (let i = 0; i < data.flag_dates.length; i++) {
						let date = new Date(data.flag_dates[i].date);
						let day = date.getDate();
						if ( day < 10 )
							day = '0' + parseInt(day);
						let month = date.getMonth() + 1;
						if ( month < 10 )
							month = '0' + parseInt(month);
						let year = date.getFullYear();
						let hours = date.getHours();
						if ( hours < 10 )
							hours = '0' + parseInt(hours);
						let minutes = date.getMinutes();
						if ( minutes < 10 )
							minutes = '0' + parseInt(minutes);
						let seconds = date.getSeconds();
						if ( seconds < 10 )
							seconds = '0' + parseInt(seconds);
						value += '<div>' + day + '/' + month + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds + '</div>';
					}
					value += '</div></div>';
					document.querySelectorAll('[data-flagcontact="' + data.flag_id + ',' + data.contact_id + '"] .dates').forEach(function(el) {
						el.innerHTML = value;
					});
				}
			}
		});
	}

}
*/